/**
 * Version stamp for the PCB Admin Panel. `VITE_APP_VERSION` is injected
 * at build time by vite.config.ts reading package.json, so the banner
 * cannot drift from the actual build. Bill 2026-05-15 incident — the
 * fallback below should never be observed in a real deploy; if it is,
 * the Vite `define` plugin is broken.
 */

export const APP_VERSION =
  (import.meta.env.VITE_APP_VERSION as string | undefined) ?? 'unknown';

export const APP_BUILD_TIME = new Date().toISOString();

export const APP_NAME = 'PCB Admin Panel';
